const EventEmitter = require('wolfy87-eventemitter');
const GraphQLClient = require('./client');

class BrowserGraphqlClient extends GraphQLClient {
  _getSocketOptions() {
    return {};
  }

  _getEventImplementation() {
    return EventEmitter;
  }
}

module.exports = BrowserGraphqlClient;
